import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import FloatingDropdownWithArrow from "../../../sharedPages/CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import Modal from "react-bootstrap/Modal";
import Payout from "./Payout";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { fetchUser } from "../../../../helpers/helper";
import { useSelector, useDispatch } from "react-redux";
import { resetOnBoardingStartContext, storeUser } from "../../../../redux/users/usersSlice";
import CloseModal from "../../OnboardingCL/CreateSubscription/CloseModal";
import {
  setComeFromPage,
  setStripeSuccessPopUp,
} from "../../../../redux/payment/payment";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { globalAllLeaderCommunities } from "../../../../store/globalstore";
import { useAtom } from "jotai";
import LoadingOverlayModal from "../../../sharedPages/LoadingOverlayModal";
const GetPaid = () => {
  const [warn, setWarn] = useState(false);
  const [isUsdtSelected, setIsUsdtSelected] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [show, setShow] = useState(true);
  const [dontCallFirstTime, setDontCallFirstTime] = useState(false);
 const onBoardingStartContext=useSelector(state=>state.user?.onBoardingStartContext);
  
  const { id } = useParams();
  const api = useApi();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { comeFromSettingPage } = useSelector((state) => state.payment);
  const verifiedmyTrade = !!(
    user?.verifiedmyTrade?.payment ||
    user?.verifiedmyTrade?.subscription?.subscriptionId
  );
  const [allLeaderCommunities, setAllLeaderCommunities] = useAtom(globalAllLeaderCommunities);
  const dispatch = useDispatch();
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  const options = ["Get paid in USDT", "Get paid in $"];

  const handleClose = () => {
    if(onBoardingStartContext){
      setShow(false);
      dispatch(resetOnBoardingStartContext()); 
      navigate(onBoardingStartContext,{replace:true});
      return;
    }
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };

  const handleNext = async () => {
    if (!selectedMethod) return;

    if (selectedMethod === "Get paid in USDT") setIsUsdtSelected(true);
    else verifyStripeConnection();
  };
  const updateVerifyStatus = async () => {

    try {
      const response = await api(
        "post",
        "authorizeNewonBoard/updateVerifyStatus",
        {
          onboarding: {
            community: [
              {
                id: user?.leaderCommunity?._id,
                message: "On boarding complete",
              },
            ],
            isVerified: true,
          },
          firstVisit: false,
          // "onboarding.subscribed": false,
          // "onboarding.connect": false,
          // "onboarding.payment": false,
          // "onboarding.isCommunityCreated": false,
        }
      );
      if(response?.status){
        // showNotificationToast("Copy trading is active!", `Your copy trading service is live and ready to share 🚀\n\nYour community can now copy your trades in just a few clicks. Once they sign up, connect, and subscribe—they’re trading what you trade.\n\nShare your landing page to start growing: ${response?.data?.businessUrls}\n\nTip:\n> Auto-share results to Telegram, Discord, or X. \n> Verify your performance for full transparency`);
      }
    } catch (error) {
      console.error("🚀 -> handleVerify -> error:", error);
    } 
  };
  const verifyStripeConnection = async () => {
    try {
      const response = await api("post", "users/checkAccount", {
        // sendEmail: true,
      });

      if (!response?.status) return toastify(response?.message, "error");

      const { data } = response;

      if (data?.user) {
        if (data?.user?.stripeCredentials?.stripeAccountLink) {
          setDontCallFirstTime(true);
          window.location.assign(
            data?.user?.stripeCredentials?.stripeAccountLink
          );
        }
      }
    } catch (error) {
      console.error("🚀 -> verifyStripeConnection -> error:", error);
    }
  };
  useEffect(()=>{
    if((isOnBoardingComplete&&user?.leaderCommunity)||(!user?.leaderCommunity)){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
    if(!isOnBoardingComplete&&user?.leaderCommunity){
      if(!user?.onboarding?.connect){
        navigate("/leader/onboarding/connection", { replace: true });
        return;
      }
      if(!user?.onboarding?.subscribed){
        navigate("/leader/onboarding/subscription", { replace: true });
        return;
      }
     
    }
  },[])
  useEffect(() => {
    if (id && !dontCallFirstTime) {
      checkStripeAccount();
    }
  }, [id]);

  const checkStripeAccount = async () => {
    try {
      // Fetch communities list if it's empty (can happen after Stripe redirect)
      let communities = allLeaderCommunities;
      if (!communities || communities.length === 0) {
        const communitiesResponse = await api("get", "multiCommunity/leaderCommunityList");
        communities = communitiesResponse?.data || [];
        setAllLeaderCommunities(communities);
      }

      const response = await api("post", "users/checkAccount");

      if (response?.status&&!(response.message==="Connect Onboarding is not completed!")) {
       
        if (user?.tradeName||(!user?.tradeName&&communities.length>1)) {         
          await updateVerifyStatus();
          // await Promise.all([fetchUser(api, dispatch, storeUser), updateVerifyStatus()]);
            navigate("/leader/onboarding/alldone", { replace: true, state: { from: "onboarding" } });
            return;
          }
        
        await Promise.all([fetchUser(api, dispatch, storeUser), sendOtp()]);

        const returnUser = response?.data.user;
        if (returnUser?.getPaidInUSD) {
         
          if (user?.socialLogin?.discord?.id) {
            navigate("/leader/onboarding/importantUpdates", { replace: true , state: { from: "onboarding" } });
          } else if (user?.socialLogin?.telegram?.id) {
            navigate("/leader/onboarding/submitNewEmail", { replace: true , state: { from: "onboarding" } });
          } else {
            if (comeFromSettingPage === "payment") {
              navigate("/leader/payment", { replace: true });
              dispatch(setComeFromPage(null));
              dispatch(setStripeSuccessPopUp(true));
              return;
            }
            navigate("/leader/onboarding/verify", { replace: true , state: { from: "onboarding" } });
          }
        } else {
          if (comeFromSettingPage === "payment") {
            navigate("/leader/payment", { replace: true });
            dispatch(setComeFromPage(null));
            dispatch(setStripeSuccessPopUp(false));
            return;
          }
          dispatch(setComeFromPage(null));
          dispatch(setStripeSuccessPopUp(false));
          toastify(response?.message, "error");
          return;
        }
      } else{
          navigate("/leader/onboarding/payout", { replace: true , state: { from: "onboarding" } });
          toastify("Please complete your setup", "error");   
      } 
    } catch (error) {
      console.error("Error:", error);
      toastify("An error occurred. Please try again.", "error");
    }
  };

  const sendOtp = async () => {
    try {
      await api("post", "authorizeNewonBoard/sendOtp");
    } catch (error) {
      console.error("🚀 -> sendOtp -> error:", error);
    }
  };

  useEffect(() => {
    if (user?.getPaidInCrypto) {
      setSelectedMethod(options[0]);
    } else if (user?.getPaidInUSD) {
      setSelectedMethod(options[1]);
    }
  }, [user]);
  
 

  return !id ? (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow">
          <button
            className="reverseArrow"
            onClick={() =>
              navigate("/leader/onboarding/subscription", { replace: true })
            }
            type="button"
          >
            <img alt="" src={Arrow} />
          </button>
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="" src={Cross} />
          </button>
          {isUsdtSelected ? (
            <Payout />
          ) : (
            <div className="onboardingContentBox top73px">
              <h2 className="title">
                <span>How do you want to get paid?</span>
                <InfoPopup
                  contentItems={[
                    { text: "Select payout", type: "heading" },
                    {
                      text: `Choose how you want to get paid.

USD payouts are processed securely via Stripe and paid out instantly.
USDT payouts are handled manually and paid monthly.`,
                      type: "paragraph",
                    },
                  ]}
                />
              </h2>
              <p className="desc bottom50px">
                Choose between $ (via Stripe.com) or USDT
              </p>
              <div className="formBox">
                <div className="mb-20px">
                  <FloatingDropdownWithArrow
                    className="onboardingInput onboardingDropdownContentWrap"
                    label="Select Payout"
                    options={options}
                    selectedValue={selectedMethod}
                    setSelectedValue={setSelectedMethod}
                    focusedAllowed={false}
                  />
                </div>

                <BubbleSvgButton
                  className="NextBtn"
                  onClick={handleNext}
                  text={"Next"}
                  type="button"
                  variant="black"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                  mainDivStyle={{
                    width: "275px",
                    height: "55px",
                  }}
                />
              </div>
            </div>
          )}
          <div className="paginationDots">
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot active"></button>
            <button className="dot"></button>
            <button className="dot"></button>
          </div>
          {/* <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div> */}
        </Modal.Body>
      </Modal>

      {warn && (
        <CloseModal handleClose={handleClose} setWarn={setWarn} warn={warn} />
      )}
    </div>
  ) : <LoadingOverlayModal/>;
};

export default GetPaid;
